<!--
 * @Description: 饼图
 * @Author: mdb
 * @Date: 2023-04-07 18:03:56
 * @LastEditTime: 2023-04-18 10:27:52
 * @LastEditors: mdb
-->
<template>
  <div class="home-echarts-wrap" :style="{ width, height }">
    <div class="home-echarts-header">
      <h3 class="home-echarts-header__title">{{ title }}</h3>
      <div class="home-echarts-header__controls">
        <CosRangePickerMonth
          style="width: 220px"
          v-model:startTime="queryForm.countDate"
          :allowClear="props.allowClear"
          @change="getData"
        />
      </div>
    </div>
    <!-- 延迟显示 loading 效果。当 spinning 状态在 delay 时间内结束，则不显示 loading 状态。 -->
    <a-spin :spinning="spinning" :delay="200">
      <!-- echarts 图表 -->
      <div ref="chartRef" class="home-echarts-content" v-show="showECharts"></div>
      <dc-layout-empty type="nothing" v-if="!showECharts" />
    </a-spin>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import { getCurrentMonthDateRange } from '@/utils/timeFormat'
import CosRangePickerMonth from '@/components/CosRangePickerMonth/index.vue'
import { zbuGetInvalidAnalysis } from '@/api/marketing/index'
import type { Ref, PropType } from 'vue'
interface ItemType {
  num: number
  invalidId: number
  invalidName: string
}

const props = defineProps({
  title: {
    type: String as PropType<string>,
    required: true
  },
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '437px'
  },
  allowClear: {
    type: Boolean as PropType<boolean>,
    default: false
  }
})

const spinning = ref(false)
const showECharts = ref(false)
const { currentDayOfMonth } = getCurrentMonthDateRange()
const queryForm = reactive({
  countDate: currentDayOfMonth
})
const getData = () => {
  spinning.value = true
  const params = { countDate: queryForm.countDate.split(' ')[0] }
  zbuGetInvalidAnalysis(params)
    .then((res) => {
      const data = res.data as unknown as ItemType[]
      if (data.length === 0) {
        showECharts.value = false
        initChart([])
      } else {
        showECharts.value = true
        initChart(data)
      }
    })
    .finally(() => {
      spinning.value = false
    })
}

const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>)
const initChart = (data: any[]) => {
  const colorArr = ['#3F97FF', '#FFB648', '#36C8E1', '#F58BEA', '#877CED']
  // 求和
  const total = data.reduce((a, b: ItemType) => a + b.num, 0)
  setOptions({
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      top: '5%',
      left: '5%'
    },
    series: [
      {
        name: '无效原因分析',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: 'center',
          color: '#4c4a4a',
          formatter: '{total|' + total + '}' + '\n\r' + '{active|总线索}',
          rich: {
            total: {
              fontSize: 24,
              fontFamily: '微软雅黑',
              fontWeight: 700,
              color: '#333333'
            },
            active: {
              fontFamily: '微软雅黑',
              fontSize: 12,
              color: '#666666',
              lineHeight: 30
            }
          }
        },
        labelLine: {
          show: false
        },
        data: data.map((item, index) => {
          return {
            value: item.num,
            name: item.invalidName,
            itemStyle: {
              color: colorArr[index % 5]
            }
          }
        })
      }
    ]
  })
}
onBeforeMount(getData)
</script>
<script lang="ts">
export default { name: 'InvalidReasonEchart' }
</script>

<style scoped></style>
